// let brands = document.getElementsByClassName("home__slider--item");
// let dots_brands = document.getElementsByClassName("dots__brands");
// let pageNumber = 1;

// nextPage();
